const purchaseDestination = process.env.REACT_APP_GTAG_ID_PURCHASE;
const subscriptionDestination = process.env.REACT_APP_GTAG_ID_SUBSCRIBE;
const googleAdsId = process.env.REACT_APP_GTAG_ID_GOOGLE_ADS;
const destinationPattern = /^AW-\d+\/[A-Za-z0-9_-]+$/;
const transactionPattern = /^dt_[a-f0-9]{64}$/;

// Only the authenticated payment response can establish amount, identity and
// payment status. Plan prices and browser timestamps are not payment evidence.
const emitGooglePayment = (measurement) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function'
    || measurement?.environment !== 'prod') return false;
  if (measurement.status === 'trial' && measurement.kind === 'subscription') {
    window.gtag('event', 'start_trial', {currency:'USD', value:0});
    return false;
  }
  if (measurement.status !== 'paid'
    || !['subscription','one_time'].includes(measurement.kind)
    || !transactionPattern.test(measurement.transactionId || '')
    || typeof measurement.value !== 'number' || !Number.isFinite(measurement.value)
    || measurement.value <= 0 || measurement.currency !== 'USD') return false;
  const destination = measurement.kind === 'subscription' ? subscriptionDestination : purchaseDestination;
  const state = window.__dtGooglePayments || (window.__dtGooglePayments = new Set());
  const key = `${measurement.kind}:${measurement.transactionId}`;
  if (state.has(key)) return false;
  const params = {transaction_id:measurement.transactionId, value:measurement.value, currency:'USD'};
  window.gtag('event', 'purchase', params);
  if (measurement.kind === 'subscription') window.gtag('event', 'subscribe', params);
  if (destinationPattern.test(destination || '')) {
    window.gtag('event', 'conversion', {send_to:destination, ...params});
  }
  state.add(key);
  return true;
};

export const trackGooglePayment = (measurement) => {
  try {
    return emitGooglePayment(measurement);
  } catch {
    // A blocked or failing analytics vendor must never break completed checkout.
    return false;
  }
};

// Ask the Google tag for its click attribution; do not scrape or create tracking
// cookies. Missing consent, a blocked tag or a timeout must not stop checkout.
export const getGoogleAdsClickId = () => new Promise(resolve => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function'
    || !/^AW-\d+$/.test(googleAdsId || '')
    || window.navigator?.globalPrivacyControl === true
    || window.navigator?.doNotTrack === '1' || window.__dtGoogleAdsConsent === 'denied') return resolve(undefined);
  let completed=false;
  const finish=value=>{
    if(completed)return;
    completed=true;clearTimeout(timeout);
    resolve(typeof value==='string' && /^[A-Za-z0-9._~-]{10,512}$/.test(value) ? value : undefined);
  };
  const timeout=setTimeout(()=>finish(undefined),500);
  try{window.gtag('get',googleAdsId,'gclid',finish);}catch{finish(undefined);}
});

export const withGoogleAdsAttribution = async payload => {
  const googleClickId=await getGoogleAdsClickId();
  return googleClickId ? {...payload,googleClickId} : payload;
};
